module.exports = __webpack_public_path__ + "img/Depression-new.6975725b.svg";